import { __assign, __values } from "tslib";
import { Kind, TypeInfo, parse, visit, visitWithTypeInfo, } from 'graphql';
import { concatInlineFragments } from '@graphql-tools/utils';
var ReplaceFieldWithFragment = /** @class */ (function () {
    function ReplaceFieldWithFragment(targetSchema, fragments) {
        var e_1, _a;
        this.targetSchema = targetSchema;
        this.mapping = {};
        try {
            for (var fragments_1 = __values(fragments), fragments_1_1 = fragments_1.next(); !fragments_1_1.done; fragments_1_1 = fragments_1.next()) {
                var _b = fragments_1_1.value, field = _b.field, fragment = _b.fragment;
                var parsedFragment = parseFragmentToInlineFragment(fragment);
                var actualTypeName = parsedFragment.typeCondition.name.value;
                if (!(actualTypeName in this.mapping)) {
                    this.mapping[actualTypeName] = Object.create(null);
                }
                var typeMapping = this.mapping[actualTypeName];
                if (!(field in typeMapping)) {
                    typeMapping[field] = [parsedFragment];
                }
                else {
                    typeMapping[field].push(parsedFragment);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (fragments_1_1 && !fragments_1_1.done && (_a = fragments_1.return)) _a.call(fragments_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    ReplaceFieldWithFragment.prototype.transformRequest = function (originalRequest) {
        var document = replaceFieldsWithFragments(this.targetSchema, originalRequest.document, this.mapping);
        return __assign(__assign({}, originalRequest), { document: document });
    };
    return ReplaceFieldWithFragment;
}());
export default ReplaceFieldWithFragment;
function replaceFieldsWithFragments(targetSchema, document, mapping) {
    var _a;
    var typeInfo = new TypeInfo(targetSchema);
    return visit(document, visitWithTypeInfo(typeInfo, (_a = {},
        _a[Kind.SELECTION_SET] = function (node) {
            var parentType = typeInfo.getParentType();
            if (parentType != null) {
                var parentTypeName_1 = parentType.name;
                var selections_1 = node.selections;
                if (parentTypeName_1 in mapping) {
                    node.selections.forEach(function (selection) {
                        if (selection.kind === Kind.FIELD) {
                            var name_1 = selection.name.value;
                            var fragments = mapping[parentTypeName_1][name_1];
                            if (fragments != null && fragments.length > 0) {
                                var fragment = concatInlineFragments(parentTypeName_1, fragments);
                                selections_1 = selections_1.concat(fragment);
                            }
                        }
                    });
                }
                if (selections_1 !== node.selections) {
                    return __assign(__assign({}, node), { selections: selections_1 });
                }
            }
        },
        _a)));
}
function parseFragmentToInlineFragment(definitions) {
    var e_2, _a, e_3, _b;
    if (definitions.trim().startsWith('fragment')) {
        var document_1 = parse(definitions);
        try {
            for (var _c = __values(document_1.definitions), _d = _c.next(); !_d.done; _d = _c.next()) {
                var definition = _d.value;
                if (definition.kind === Kind.FRAGMENT_DEFINITION) {
                    return {
                        kind: Kind.INLINE_FRAGMENT,
                        typeCondition: definition.typeCondition,
                        selectionSet: definition.selectionSet,
                    };
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    var query = parse("{" + definitions + "}").definitions[0];
    try {
        for (var _e = __values(query.selectionSet.selections), _f = _e.next(); !_f.done; _f = _e.next()) {
            var selection = _f.value;
            if (selection.kind === Kind.INLINE_FRAGMENT) {
                return selection;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_3) throw e_3.error; }
    }
    throw new Error('Could not parse fragment');
}
//# sourceMappingURL=ReplaceFieldWithFragment.js.map